import { requestCDN } from "../../apis";
import localStorageKey from "../../enumerations/localStorageKey";

const currency =
  window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
  process.env.REACT_APP_DEFAULT_CURRENCY;
const lang = window.localStorage.getItem(localStorageKey.LANG_SETTING);

export const apiGetNotice = (params) => {
  const millis = Date.now();
  return requestCDN(
    "get",
    `/${currency?.toUpperCase()}/notice/${lang ? lang : process.env.REACT_APP_DEFAULT_LANG}.json?v=${millis}`,
  );
  // return requestGlobalSettingData("get", `/${currency}/notice`, params, false, false);
};
